import React from 'react';
import { motion } from 'framer-motion';
import { questions } from '../data/questions';
interface QuizScreenProps {
  currentQuestionIndex: number;
  onAnswer: (answer: string) => void;
}
export const QuizScreen: React.FC<QuizScreenProps> = ({
  currentQuestionIndex,
  onAnswer
}) => {
  const question = questions[currentQuestionIndex];
  const progress = (currentQuestionIndex + 1) / questions.length * 100;
  return <div className="flex flex-col items-center min-h-screen px-4 py-12 bg-cream font-sans" data-id="element-250">
      <div className="max-w-[600px] w-full flex flex-col" data-id="element-251">
        {/* Progress Bar */}
        <div className="mb-10 w-full" data-id="element-252">
          <div className="flex justify-between items-center mb-2" data-id="element-253">
            <span className="text-xs font-semibold text-forest-green uppercase tracking-wider" data-id="element-254">
              Pregunta {currentQuestionIndex + 1} de {questions.length}
            </span>
            <span className="text-xs text-muted-text font-medium" data-id="element-255">
              {Math.round(progress)}%
            </span>
          </div>
          <div className="w-full h-1.5 bg-[#E8E2D5] rounded-full overflow-hidden" data-id="element-256">
            <motion.div className="h-full bg-forest-green" initial={{
            width: `${currentQuestionIndex / questions.length * 100}%`
          }} animate={{
            width: `${progress}%`
          }} transition={{
            duration: 0.5,
            ease: 'easeInOut'
          }} data-id="element-257" />
          </div>
        </div>

        {/* Question */}
        <motion.div key={currentQuestionIndex} initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -20
      }} transition={{
        duration: 0.3
      }} className="flex flex-col" data-id="element-258">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark-text mb-2 leading-tight text-center" data-id="element-259">
            {question.text}
          </h2>
          <p className="text-muted-text text-sm italic mb-8 text-center" data-id="element-260">
            (solo toca tu respuesta)
          </p>

          {/* Options */}
          <div className="flex flex-col gap-3" data-id="element-261">
            {question.options.map((option, index) => <button key={index} onClick={() => onAnswer(option)} className="w-full text-left p-5 rounded-xl border-2 border-transparent bg-white shadow-sm hover:border-forest-green hover:bg-mint-green/20 transition-all duration-200 text-dark-text font-medium text-[1.05rem]" data-id="element-262">
                {option}
              </button>)}
          </div>
        </motion.div>
      </div>
    </div>;
};